import { faro } from '../sdk';
export class BaseExtension {
    get faro() {
        return faro;
    }
    logDebug(...args) {
        var _a, _b;
        (_b = (_a = this.faro) === null || _a === void 0 ? void 0 : _a.internalLogger) === null || _b === void 0 ? void 0 : _b.debug(`${this.name}\n`, ...args);
    }
    logInfo(...args) {
        var _a, _b;
        (_b = (_a = this.faro) === null || _a === void 0 ? void 0 : _a.internalLogger) === null || _b === void 0 ? void 0 : _b.info(`${this.name}\n`, ...args);
    }
    logWarn(...args) {
        var _a, _b;
        (_b = (_a = this.faro) === null || _a === void 0 ? void 0 : _a.internalLogger) === null || _b === void 0 ? void 0 : _b.warn(`${this.name}\n`, ...args);
    }
    logError(...args) {
        var _a, _b;
        (_b = (_a = this.faro) === null || _a === void 0 ? void 0 : _a.internalLogger) === null || _b === void 0 ? void 0 : _b.error(`${this.name}\n`, ...args);
    }
}
//# sourceMappingURL=extensions.js.map